import styled from "styled-components";
import { Section, Container, CTA } from "components/shared";
import respondTo from "util/respondTo";

export const NewSection = styled(Section)`
    background: var(--dark);
`;

export const Form = styled.form`
    padding: 1rem;
    background: var(--dark);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const ContactContainer = styled(Container)`
    background: var(--dark-2);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 1.5rem;
    gap: 2rem;

    ${respondTo.sm`
        grid-template-columns: 1fr;
       
    `}
`;

export const TalkIcon = styled.img`
    display: block;
    width: 100%;
    height: auto;
`;

export const Field = styled.div`
margin-bottom:1rem;
    label {
        display: block;
        margin-bottom: 0.5rem;
    }
`;

export const Input = styled.input`
    font-size: 1rem;
    padding: 0.5rem 1rem;
    width: 100%;

    &:active,
    &:focus {
        outline: 0.3rem solid var(--main);
    }
`;
export const Message = styled(Input)`
    font-size: 1rem;
    padding: 0.5rem 1rem;
    height: 10rem;
    display: flex;
`;

export const Submit = styled(CTA)`
    font-size: 1rem;
    padding:0.8em 0.5em;
    width: 100%;
    display: block;
    text-align: center;
    color: white;
`;

export const AlertMsg = styled.p`
    position: fixed;
    z-index: 20;
    top: 20%;
    left: 50%;
    transform: translateX(-50%)
        scale(${({ isDisplayed }) => (isDisplayed ? 1 : 0)});
    padding: 0.5em 1.5em;
    color: white;
    background: ${({ bg }) => (bg === "lime" ? "limegreen" : "crimson")};
`;
